<template>
  <div class="CoalModel_box">
    <div v-if="!isAdjust">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        ref="form"
        size="small"
      >
        <el-form-item label="">
          <el-input v-model="form.name" placeholder="请输入煤种"></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            @click="getCoalTypeList(true)"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="getReset"
            type="primary"
          />
        </el-form-item>
      </el-form>
      <el-table
        v-loading="loading"
        :data="tableData"
        stripe
        size="mini"
        style="width: 100%"
      >
        <el-table-column type="index" align="center" width="120" fixed label="序号">
        </el-table-column>
        <el-table-column prop="coalCategoryName" label="煤种"></el-table-column>
        <el-table-column prop="price" label="价格（元/吨）"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="updateTime" label="最后修改时间"></el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding: 20px">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="form.pageNo"
          :page-size="form.pageSize"
          :total="totalSize"
          style="float: right"
        >
        </el-pagination>
      </div>
    </div>
    <!--调整历史-->
    <AdjustHistory v-if="isAdjust" @Adjust="AdjustFun" />
    
  </div>
</template>
<script>
import KtButton from "@/components/Core/KtButton";
export default {
  props: {
    coalMineNo: {
      type: [String],
      default: 100,
    },
  },
  components: {
    KtButton,
  },
  data() {
    return {
      tableData: [],
      isAdjust: false,
      size: "small",
      loading: false,
      title: "",
      form: {
        pageNo: 1,
        pageSize: 10,
        name: ""
      },
      totalSize: 0
    };
  },
  mounted() {
    this.getCoalTypeList(true);
  },
  methods: {
    // 请求数据
    getCoalTypeList(val) {
      const _t = this;
      if (val) {
        _t.form.pageNo = 1;
      }
      _t.loading = true;
      let obj = { ..._t.form, coalMineNo: _t.coalMineNo };
      var newObj = {};
      for (var attr in obj) {
        if (
          obj.hasOwnProperty(attr) &&
          obj[attr] !== "" &&
          obj[attr] !== null &&
          obj[attr] !== undefined
        ) {
          if (obj[attr] instanceof Object) {
            newObj[attr] = removeEmptyField(obj[attr]);
          } else if (
            typeof obj[attr] == "string" &&
            ((obj[attr].indexOf("{") > -1 && obj[attr].indexOf("}") > -1) ||
              (obj[attr].indexOf("[") > -1 && obj[attr].indexOf("]") > -1))
          ) {
            try {
              var attrObj = JSON.parse(obj[attr]);
              if (attrObj instanceof Object) {
                newObj[attr] = removeEmptyField(attrObj);
              }
            } catch (e) {
              newObj[attr] = obj[attr];
            }
          } else {
            newObj[attr] = obj[attr];
          }
        }
      }
      // Object.keys(form).map(key => (!form[key] ? delete form[key] : ''))
      _t.$api.coalModel.coalcategoryList(newObj).then((res) => {
        if (res.code === "0") {
          _t.tableData = res.data.dtoList;
          _t.totalSize = res.data.totalSize;
          _t.loading = false;
        } else {
          _t.loading = false;
          _t.$message({
            message: "查询失败, " + res.message,
            type: "error",
          });
        }
      });
    },

    // 重置
    getReset() {
      this.form.name = "";
      this.form.status = "";
      this.getCoalTypeList(true);
    },

    // 点击调整历史
    getAdjust() {
      this.isAdjust = true;
    },

    // 接受调整历史子组件传回的值
    AdjustFun(val) {
      this.isAdjust = val;
    },

    // 换页刷新
    refreshPageRequest(pageNo) {
      this.form.pageNo = pageNo;
      this.getCoalTypeList(false);
    }
  },
};
</script>
<style lang="scss">
.CoalModel_box {
  .CoalModel_box_title {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 0 0;

    .CoalModel_box_title_desc {
      font-size: 18px;
      font-weight: 600;
    }

    .CoalModel_box_title_cz {
      color: #25aff3;
      cursor: pointer;
    }
  }

  .CoalModel_box_dialog {
    display: flex;
    justify-content: space-around;

    .CoalModel_box_dialog_nr {
      width: 33%;

      div:first-child {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 10px;
      }
    }
  }

  .CoalModel_box_dialog_nr_ts {
    text-align: center;
    margin-top: 20px;
    font-weight: 600;
    font-size: 16px;
  }
}
</style>
